import React from 'react'
import { BackButton, baseUrl } from './Examples'
import DropdownFilters from '../shared/DropdownFilters.tsx'

const ExampleDropdownFilters = (): JSX.Element => {
    return (
        <div style={{ top: 100, position: 'relative' }}>
            <BackButton href={baseUrl} />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '60%',
                    margin: 'auto',
                    border: '1px solid #e0e0e0',
                }}
            >
                <DropdownFilters
                    options={[
                        {
                            title: 'Filters example',
                            field: 'filters',
                            options: [
                                { value: 'option1', label: 'Option 1' },
                                { value: 'option2', label: 'Option 2' },
                                { value: 'option3', label: 'Option 3' }
                            ]
                        }
                    ]}
                    callback={() => Promise.resolve(alert('callback'))}
                />
            </div>
        </div>
    )
}

export default ExampleDropdownFilters
